export const SITE_URL = 'https://busiconn.com';
export const DEFAULT_IMAGE = `${SITE_URL}/assets/images/profile.png`;
export const DEFAULT_TITLE = 'Busiconn | Buy, Sell & Make Protected Deals';
export const DEFAULT_DESCRIPTION = 'Discover products and services, chat directly with sellers and freelancers, and manage your deals with protected payments on Busiconn.';
export const SITE_STRUCTURED_DATA = [
  { '@context': 'https://schema.org', '@type': 'Organization', '@id': `${SITE_URL}/#organization`, name: 'Busiconn', url: `${SITE_URL}/`, logo: DEFAULT_IMAGE },
  { '@context': 'https://schema.org', '@type': 'WebSite', '@id': `${SITE_URL}/#website`, name: 'Busiconn', url: `${SITE_URL}/`, description: DEFAULT_DESCRIPTION, publisher: { '@id': `${SITE_URL}/#organization` } },
];

// Account and deal data stay behind the existing authentication checks.
export const PUBLIC_PAGES = {
  '/': [DEFAULT_TITLE, DEFAULT_DESCRIPTION],
  '/home': ['Products & Services | Busiconn', 'Discover products and services on Busiconn. Connect with sellers and freelancers, discuss your requirements, and make protected deals.'],
  '/explore': ['Explore Products & Services | Busiconn', 'Explore offers from sellers and freelancers on Busiconn. Find products and services, start a conversation, and agree on your next deal.'],
  '/dealers': ['Discover Sellers & Freelancers | Busiconn', 'Find sellers and freelancers on Busiconn and connect directly to discuss products, services, and business deals.'],
  '/faq': ['Frequently Asked Questions | Busiconn', 'Find answers to common questions about buying, selling, and using Busiconn.'],
  '/busiconn-user-guide': ['User Guide | Busiconn', 'Learn how to use Busiconn to discover offers, chat, and manage your deals.'],
  '/privacy-policy': ['Privacy Policy | Busiconn', 'Read how Busiconn handles your personal information and privacy.'],
  '/termsandconditions': ['Terms & Conditions | Busiconn', 'Read the terms and conditions for using Busiconn.'],
  '/data-deletion': ['Account & Data Deletion | Busiconn', 'Learn how to request deletion of your Busiconn account and associated data.'],
};

const ALIASES = {
  '/privacy-policies': '/privacy-policy',
  '/termandcondition': '/termsandconditions',
  '/busiconn-guide': '/busiconn-user-guide',
};

export function getPageMetadata(pathname = '/') {
  const path = pathname.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  const canonicalPath = ALIASES[path] || path;
  const page = PUBLIC_PAGES[canonicalPath];
  const isPost = /^\/posts\/[^/]+$/.test(path);
  return {
    title: page?.[0] || (isPost ? 'Post | Busiconn' : 'Busiconn'),
    description: page?.[1] || DEFAULT_DESCRIPTION,
    canonicalUrl: `${SITE_URL}${canonicalPath}`,
    // Includes account, paused live and unknown routes. Not access control.
    noIndex: !page && !isPost,
  };
}

export function serializeStructuredData(data) {
  return JSON.stringify(data).replace(/</g, '\\u003c');
}
